export const pushNavigationStateMock = {
  navigatedFromAppId: 'itero-aohs',
  urlFrom: 'http://localhost:3400/home',
  navigatedToAppId: 'dental-xrai',
};
